import { RxMinus, RxPlus } from "react-icons/rx";

import { VariantLabel } from "~/components/atoms/VariantLabel";
import type { MinimalCardType } from "~/types/card";

export const CollectionListTeaserVariant = ({
  variant,
  onChange,
}: {
  variant: MinimalCardType["variants"][0] & { quantity?: number };
  onChange: (vId: string, quantity: number) => void;
}) => {
  return (
    <div className="relative text-text-color">
      <div
        className={
          "inset-arrow relative inline-flex h-[20px] flex-row items-center justify-between pt-0.5"
        }
      >
        <div className={"inset-arrow-target flex items-center pl-6"}>
          <span className="inline-block w-[12px]">{variant.quantity ?? 1}</span>
          <VariantLabel variant={variant} size="sm" />
        </div>
      </div>

      <div className="absolute right-2 top-1 cursor-pointer px-2">
        <RxMinus
          size={16}
          className="hover:text-primary -mt-0.5 mr-2 inline text-white transition-colors animate-in fade-in"
          onClick={() => onChange(variant.id, (variant.quantity ?? 1) - 1)}
        />
        <RxPlus
          size={17}
          onClick={() => onChange(variant.id, (variant.quantity ?? 1) + 1)}
          className="hover:text-primary -mt-0.5 inline text-white transition-colors animate-in fade-in"
        />
      </div>
    </div>
  );
};
